import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios';
import Config from '../../Constants/index'
import Alert from '../../Component/Alert';
import CustomerLkp from '../../Component/CustomerLkp';
import EquipmentLkp from '../../Component/EquipmentLkp';
import UserLkp from '../../Component/UserLkp';
import UserDefaultCustomer from '../../Component/Calibration/UserDefaultCustomer';
import moment from 'moment';
import DocTypeLkp from '../../Component/DocumentControl/DocTypeLkp';
import LangLkp from '../../Component/DocumentControl/LangLkp'
import CompanyLkp from '../../Component/DocumentControl/CompanyLkp'
import DivisionLkp from '../../Component/DocumentControl/DivisionLkp';
import FileUploader from "../../Component/DocumentControl/FileUploader";
import NavBar from '../../Navigation/NavBar';
import Footer from '../../Navigation/Footer';
import { getIdToken } from "firebase/auth";
import DocLkp from './EngDocLkp';

export default class EngDoc_Add extends Component {

    constructor(props) {
        super(props);

        let id = 0;
        let isEdit = false;

        // if (this.props.match.params.Id) {
        //     id = this.props.match.params.Id;
        //     isEdit = true;
        // };

        this.state = {
            Id: id, isEdit, Title: '', Short: '', isRedirectDoc: false,
            DocTypeRef: 0,
            LangRef: 0,
            CompanyRef: 0,
            ParentRef : 0,
            DivisionRef: 0,
            messages: [],
            CompanyPreFix: '***',
            DivisionPreFix: '***',
            DocTypePreFix: '***',
            LangPreFix: '***',
            parentDocCode:'',
            RevisionDate: null,
            RevisionNumber: 0,
            FileTblId: 0
        };

        this.PAGE_TITLE = "New Eng Doc Code";

        this.onChange = this.onChange.bind(this);
        this.cancel = this.cancel.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.addEdit = this.addEdit.bind(this);
        this.edit = this.edit.bind(this);
        this.onCompanyChange = this.onCompanyChange.bind(this);
        this.onParentChange = this.onParentChange.bind(this);
        this.onDivisionChange = this.onDivisionChange.bind(this);
        this.onDocTypeChange = this.onDocTypeChange.bind(this);
        this.onLangChange = this.onLangChange.bind(this);
        this.onUploadSuccess = this.onUploadSuccess.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
        this.onRevisionNumberChange = this.onRevisionNumberChange.bind(this);
    }

    onChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    
    onRevisionNumberChange(event) {
        const target = event.target;

        this.setState({
            RevisionNumber: parseInt(target.value)
        });       
    }

    onCompanyChange(event, preFix) {
        const target = event.target;
        const value = parseInt(target.value);
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.setState({ [name]: value });
        this.setState({ CompanyPreFix: preFix });
    }

    onParentChange(event) {
        const target = event.target;
        const value =  parseInt(target.value);
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.setState({ [name]: value });        
    }

    onDivisionChange(event, preFix) {
        const target = event.target;
        const value =  parseInt(target.value);
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.setState({ [name]: value });
        this.setState({ DivisionPreFix: preFix });
    }

    onDocTypeChange(event, preFix) {
        const target = event.target;
        const value =  parseInt(target.value);
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.setState({ [name]: value });
        this.setState({ DocTypePreFix: preFix });
    }

    onLangChange(event, preFix) {
        const target = event.target;
        const value =  parseInt(target.value);
        const name = target.name;

        this.setState({
            [name]: value
        });

        this.setState({ [name]: value });
        this.setState({ LangPreFix: preFix });
    }

    cancel = () => {
        this.setState({ isRedirectDoc: true })
    }

    fetchData() {    


        Axios.get(Config.API_URL + "CertificateOfCalibration/GetCertificateOfCalibration/?id=" + this.state.Id + "&timestamp=" + new Date().getTime(),
            { headers: { 
                'Authorization': 'Bearer ' + this.props.user.accessToken }
            })
            .then(response => {
                //TODO
                //this.setState({ Title: response.data.title });              
            });
    }

    componentDidMount() {
        if (this.state.isEdit)
            this.fetchData();
    }

    addEdit() {
        if (this.state.isEdit)
            this.edit();
        else
            this.add();
    }

    add() {
        let messages = [];
        let self = this;
        debugger;

        getIdToken(this.props.user).then((idToken)=> { 


        Axios.post(Config.API_URL + "EngDoc/AddFullEngDoc",
            {
                EngDocTypeRef: this.state.DocTypeRef,
                LangRef: this.state.LangRef,
                CompanyRef: this.state.CompanyRef,
                DivisionRef:this.state.DivisionRef,
                Title: this.state.Title,
                RevisionDate: this.state.RevisionDate,
                RevisionNumber: this.state.RevisionNumber,
                FileTblId : this.state.FileTblId,
                ParentRef : this.state.ParentRef 
            },
            { headers: { 'Authorization': 'Bearer ' + idToken } })
            .then(response => {
                let id = response.data;
                this.setState({ Id: id, isRedirectDoc: true });
            })
            .catch(error => {
                if (error.response && error.response.status == 400) {
                    error.response.data.message.map(p => {
                        messages.push(p);
                    })
                }
                else {
                    //messages.push("خطا در برقراری ارتباط با سرور - در صورت استفاده از پروکسی آنرا غیر فعال نمایید")
                    messages.push("Failed to connect to server")
                }
                self.setState({ messages, isInsert: true });
            });
        });        
    }

    edit() {

        let messages = [];
        let self = this;
        debugger;

        Axios.post(Config.API_URL + "Town_Unit/edit",
            {
                Id: this.state.Id,
                Title: this.state.Title
            },
            { headers: { token: window.localStorage.getItem("apiToken") } })
            .then(response => {
                let id = response.data;
                this.setState({ Id: id, isRedirectUnit: true });
            })
            .catch(error => {
                if (error.response && error.response.status == 400) {
                    error.response.data.message.map(p => {
                        messages.push(p);
                    })
                }
                else {
                    //messages.push("خطا در برقراری ارتباط با سرور - در صورت استفاده از پروکسی آنرا غیر فعال نمایید")
                    messages.push("Failed to connect to server")
                }
                self.setState({ messages, isInsert: true });
            });
    }

    onUploadSuccess = (fileTblId) => {
        this.setState({ FileTblId: fileTblId });
    };

    onUploadError = () => {
        this.setState({ FileTblId: 0 });
    };

    render() {
        if (this.state.isRedirectDoc) {
            return <Redirect to={"/EngDoc/"}></Redirect>
        }

        return (
            <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
                {/* Navbar */}
                <NavBar />
                <div className="container-fluid py-4">
                    <div className="col-lg-9 col-12 mx-auto position-relative">
                        <div className="card">





                            <div className="card-header p-3 pt-2">
                                <div className="icon icon-lg icon-shape bg-gradient-dark shadow text-center border-radius-xl mt-n4 me-3 float-start">
                                    <i class="fa fa fa-file-alt fa-fw" aria-hidden="true"></i>
                                </div>
                                <h6 className="mb-0">New Eng Document</h6>
                            </div>

                            <div className="card-body pt-2">
                                <div className="row">
                                    <div className="col-md-6 mb-md-0 mb-4">
                                        <div className="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row">
                                            {/* <img className="w-10 me-3 mb-0" src="../../../assets/img/logos/mastercard.png" alt="logo" /> */}
                                            <h6 className="mb-0">
                                                {/* ****&nbsp;&nbsp;&nbsp;****&nbsp;&nbsp;&nbsp;****&nbsp;&nbsp;&nbsp;**** */}
                                                {this.state.CompanyPreFix + '-' + this.state.DivisionPreFix + '-' +
                                                    this.state.DocTypePreFix + '-' + this.state.LangPreFix + "-####"}
                                            </h6>

                                            {/* <i className="material-icons ms-auto text-dark cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top" title data-bs-original-title="Edit Card">edit</i> */}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="card-body pt-2">
                                
                                <div class="input-group input-group-static mb-4">
                                    <label for="exampleFormControlSelect1" class="ms-0">Company</label>
                                    <CompanyLkp name="CompanyRef" user={this.props.user} onChange={this.onCompanyChange} value={this.state.CompanyRef} />
                                </div>

                                <div class="input-group input-group-static mb-4">
                                    <label for="exampleFormControlSelect1" class="ms-0">Division</label>
                                    <DivisionLkp name="DivisionRef" user={this.props.user} onChange={this.onDivisionChange} value={this.state.DivisionRef} />
                                </div>

                                <div class="input-group input-group-static mb-4">
                                    <label for="exampleFormControlSelect1" class="ms-0">Type</label>
                                    <DocTypeLkp name="DocTypeRef" user={this.props.user} onChange={this.onDocTypeChange} value={this.state.DocTypeRef} />
                                </div>

                                <div class="input-group input-group-static mb-4">
                                    <label for="exampleFormControlSelect1" class="ms-0">Language</label>
                                    <LangLkp name="LangRef" user={this.props.user} onChange={this.onLangChange} value={this.state.LangRef} />
                                </div>


                                <div className="row"> 
                                    <div className="col-12">
                                        <div className="input-group input-group-static">
                                            <label>Title</label>
                                            {/* <input type="text" className="form-control" placeholder="Alec" onfocus="focused(this)" onfocusout="defocused(this)" /> */}
                                            <input type="text" class="form-control" name="Title" onChange={this.onChange} value={this.state.Title} />
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div className="input-group input-group-static my-3">
                                            <label>Revision Date</label>
                                            <input type="date" className="form-control" name="RevisionDate" onChange={this.onChange} value={this.state.RevisionDate} />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div className="input-group input-group-static my-3">
                                            <label>Revision Number</label>
                                            <input type="number" className="form-control" name="RevisionNumber" min="0" step="1" onChange={this.onRevisionNumberChange} value={this.state.RevisionNumber} />
                                        </div>
                                    </div>
                                </div>

                                <div class="input-group input-group-static mb-4">
                                    <label for="exampleFormControlSelect1" class="ms-0">Parent Doc</label>
                                    <DocLkp name="ParentRef" parentOnly={true} 
                                        user={this.props.user} onChange={this.onParentChange} value={this.state.ParentRef} />
                                </div>        


                                {/* <div class="form-group">
                                    <label for="exampleInputEmail">
                                        File
                                    </label>
                                    <FileUploader
                                        onUploadSuccess={this.onUploadSuccess}
                                        onUploadError={this.onUploadError}
                                        user={this.props.user}
                                    />
                                </div> */}

                                {/* <LkpDoc user={this.props.user} /> */}
                              
                                {this.state.messages.length > 0 &&
                                    <Alert messages={this.state.messages}></Alert>}



                                {/* <div className="row mt-4">
      <div className="col-12 col-md-6">
        <div className="form-group">
          <label>
            Private Project
          </label>
          <p className="form-text text-muted ms-1">
            If you are available for hire outside of the current situation, you can encourage others to hire you.
          </p>
          <div className="form-check form-switch ms-1">
            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" onclick="notify(this)" data-type="warning" data-content="Once a project is made private, you cannot revert it to a public project." data-title="Warning" data-icon="ni ni-bell-55" />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault" />
          </div>
        </div>
      </div>
    </div> */}
                                {/* <label className="mt-4">Project Description</label>
    <p className="form-text text-muted ms-1">
      This is how others will learn about the project, so make it good!
    </p>
    <div className="ql-toolbar ql-snow"><span className="ql-formats"><span className="ql-header ql-picker"><span className="ql-picker-label" tabIndex={0} role="button" aria-expanded="false" aria-controls="ql-picker-options-0"><svg viewBox="0 0 18 18"> <polygon className="ql-stroke" points="7 11 9 13 11 11 7 11" /> <polygon className="ql-stroke" points="7 7 9 5 11 7 7 7" /> </svg></span><span className="ql-picker-options" aria-hidden="true" tabIndex={-1} id="ql-picker-options-0"><span tabIndex={0} role="button" className="ql-picker-item" data-value={1} /><span tabIndex={0} role="button" className="ql-picker-item" data-value={2} /><span tabIndex={0} role="button" className="ql-picker-item" data-value={3} /><span tabIndex={0} role="button" className="ql-picker-item" /></span></span><select className="ql-header" style={{display: 'none'}}><option value={1} /><option value={2} /><option value={3} /><option selected="selected" /></select></span><span className="ql-formats"><button type="button" className="ql-bold"><svg viewBox="0 0 18 18"> <path className="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z" /> <path className="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z" /> </svg></button><button type="button" className="ql-italic"><svg viewBox="0 0 18 18"> <line className="ql-stroke" x1={7} x2={13} y1={4} y2={4} /> <line className="ql-stroke" x1={5} x2={11} y1={14} y2={14} /> <line className="ql-stroke" x1={8} x2={10} y1={14} y2={4} /> </svg></button><button type="button" className="ql-underline"><svg viewBox="0 0 18 18"> <path className="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3" /> <rect className="ql-fill" height={1} rx="0.5" ry="0.5" width={12} x={3} y={15} /> </svg></button><button type="button" className="ql-link"><svg viewBox="0 0 18 18"> <line className="ql-stroke" x1={7} x2={11} y1={7} y2={11} /> <path className="ql-even ql-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z" /> <path className="ql-even ql-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z" /> </svg></button></span><span className="ql-formats"><button type="button" className="ql-list" value="ordered"><svg viewBox="0 0 18 18"> <line className="ql-stroke" x1={7} x2={15} y1={4} y2={4} /> <line className="ql-stroke" x1={7} x2={15} y1={9} y2={9} /> <line className="ql-stroke" x1={7} x2={15} y1={14} y2={14} /> <line className="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5" /> <path className="ql-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z" /> <path className="ql-stroke ql-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156" /> <path className="ql-stroke ql-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109" /> </svg></button><button type="button" className="ql-list" value="bullet"><svg viewBox="0 0 18 18"> <line className="ql-stroke" x1={6} x2={15} y1={4} y2={4} /> <line className="ql-stroke" x1={6} x2={15} y1={9} y2={9} /> <line className="ql-stroke" x1={6} x2={15} y1={14} y2={14} /> <line className="ql-stroke" x1={3} x2={3} y1={4} y2={4} /> <line className="ql-stroke" x1={3} x2={3} y1={9} y2={9} /> <line className="ql-stroke" x1={3} x2={3} y1={14} y2={14} /> </svg></button></span><span className="ql-formats"><button type="button" className="ql-clean"><svg className viewBox="0 0 18 18"> <line className="ql-stroke" x1={5} x2={13} y1={3} y2={3} /> <line className="ql-stroke" x1={6} x2="9.35" y1={12} y2={3} /> <line className="ql-stroke" x1={11} x2={15} y1={11} y2={15} /> <line className="ql-stroke" x1={15} x2={11} y1={11} y2={15} /> <rect className="ql-fill" height={1} rx="0.5" ry="0.5" width={7} x={2} y={14} /> </svg></button></span></div><div id="editor" className="ql-container ql-snow"><div className="ql-editor" data-gramm="false" contentEditable="true"><p>Hello World!</p><p>Some initial <strong>bold</strong> text</p><p><br /></p></div><div className="ql-clipboard" contentEditable="true" tabIndex={-1} /><div className="ql-tooltip ql-hidden"><a className="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank" /><input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL" /><a className="ql-action" /><a className="ql-remove" /></div></div>
    <label className="mt-4 form-label">Project Tags</label>
    <div className="choices" data-type="select-multiple" role="combobox" aria-autocomplete="list" aria-haspopup="true" aria-expanded="false"><div className="choices__inner"><select className="form-control choices__input" name="choices-multiple-remove-button" id="choices-multiple-remove-button" multiple hidden tabIndex={-1} data-choice="active"><option value="Choice 2">Choice 2</option><option value="Choice 3">Choice 3</option><option value="Three">Label Three</option></select><div className="choices__list choices__list--multiple"><div className="choices__item choices__item--selectable" data-item data-id={3} data-value="Choice 2" data-custom-properties="null" aria-selected="true" data-deletable>Choice 2<button type="button" className="choices__button" aria-label="Remove item: 'Choice 2'" data-button>Remove item</button></div><div className="choices__item choices__item--selectable" data-item data-id={4} data-value="Choice 3" data-custom-properties="null" aria-selected="true" data-deletable>Choice 3<button type="button" className="choices__button" aria-label="Remove item: 'Choice 3'" data-button>Remove item</button></div><div className="choices__item choices__item--selectable" data-item data-id={5} data-value="Three" data-custom-properties="null" aria-selected="true" data-deletable>Label Three<button type="button" className="choices__button" aria-label="Remove item: 'Three'" data-button>Remove item</button></div></div><input type="text" className="choices__input choices__input--cloned" autoComplete="off" autoCapitalize="off" spellCheck="false" role="textbox" aria-autocomplete="list" aria-label="false" aria-activedescendant="choices--choices-multiple-remove-button-item-choice-6" style={{minWidth: '1ch', width: '1ch'}} /></div><div className="choices__list choices__list--dropdown" aria-expanded="false"><div className="choices__list" aria-multiselectable="true" role="listbox"><div id="choices--choices-multiple-remove-button-item-choice-1" className="choices__item choices__item--choice choices__item--selectable" role="option" data-choice data-id={1} data-value="Choice 1" data-select-text="Press to select" data-choice-selectable>Choice 1</div><div id="choices--choices-multiple-remove-button-item-choice-4" className="choices__item choices__item--choice choices__item--selectable" role="option" data-choice data-id={4} data-value="Choice 4" data-select-text="Press to select" data-choice-selectable>Choice 4</div><div id="choices--choices-multiple-remove-button-item-choice-5" className="choices__item choices__item--choice choices__item--disabled" role="option" data-choice data-id={5} data-value="One" data-select-text="Press to select" data-choice-disabled aria-disabled="true">Label One</div><div id="choices--choices-multiple-remove-button-item-choice-6" className="choices__item choices__item--choice choices__item--selectable is-highlighted" role="option" data-choice data-id={6} data-value="Two" data-select-text="Press to select" data-choice-selectable aria-selected="true">Label Two</div></div></div></div> */}
                                {/* <div className="row">
      <div className="col-6">
        <div className="input-group input-group-static">
          <label>Start Date</label>
          <input className="form-control datetimepicker flatpickr-input" type="text" data-input onfocus="focused(this)" onfocusout="defocused(this)" />
        </div>
      </div>
      <div className="col-6">
        <div className="input-group input-group-static">
          <label>End Date</label>
          <input className="form-control datetimepicker flatpickr-input" type="text" data-input onfocus="focused(this)" onfocusout="defocused(this)" />
        </div>
      </div>
    </div> */}
                                {/* <div className="input-group input-group-dynamic mt-4">
      <label className="form-label">Starting Files</label>
      <form action="/file-upload" className="form-control dropzone dz-clickable" id="dropzone">
        <div className="dz-default dz-message"><button className="dz-button" type="button">Drop files here to upload</button></div></form>
    </div> */}
                                <div className="d-flex justify-content-end mt-4">


                                    <button type="button" class="btn btn-light m-0" onClick={this.cancel}>
                                        Cancel
                                    </button>
                                    <button type="button" class="btn bg-gradient-dark m-0 ms-2" onClick={this.addEdit}>
                                        Save
                                    </button>




                                </div>
                            </div>
                        </div>





                    </div>




                </div>

                <Footer />
            </main>









            /************************************************* */


        )
    }
}
